import { Controller } from "stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static targets = [ "content" ]

  connect() {
    this.modal = this.element;
    document.body.classList.add("modal-open");
    useClickOutside(this, { element: this.contentTarget });
  }

  close() {
    document.body.classList.remove("modal-open");
    document.getElementsByClassName("modal-backdrop")[0].remove();
    this.modal.remove();
    document.getElementById('modal').setAttribute('src', '');
  }

  escClose(event) {
    if (event.key === "Escape") this.close();
  }

  clickOutside(event) {
    event.preventDefault();
    this.close();
  }
}
